function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import Button from '@material-ui/core/Button';
import React from 'react';
/**
 * The DialogAction component is preferred when adding buttons to a
 * DialogActions component.
 *
 * Rather than leave it up to each dialog to define the correct variants and
 * colours to use for the action buttons (e.g. save, cancel, etc.), this
 * component ensures consistency by abstracting the action buttons based on the
 * type of action that they perform.
 *
 * For example, dismissive buttons (e.g. cancel, no, etc.) should have lower
 * visual emphasis than primary buttons (e.g. save, yes, etc.), while secondary
 * buttons (e.g. delete, etc.) should be given a different emphasis to indicate
 * to the user that they perform a different action.
 */

var DialogAction = function DialogAction(_ref) {
  var children = _ref.children,
      variant = _ref.variant,
      other = _objectWithoutProperties(_ref, ["children", "variant"]);

  var buttonVariant = variant === 'primary' || variant === 'secondary' ? 'contained' : 'text';
  var buttonColour = variant === 'secondary' ? 'secondary' : 'primary';
  return React.createElement(Button, _extends({
    color: buttonColour,
    variant: buttonVariant
  }, other), children);
};

export default DialogAction;